export const DeliveryProfileStorageKey = 'delivery-profile';
